<template>
  <component :is="selection_sunday_reaction_component" :section="section" />
</template>

<script>
import ContentSelectionSundayReactionDesktop from "@/components/Content/ContentSelectionSundayReactionDesktop";
import ContentSelectionSundayReactionMobile from "@/components/Content/ContentSelectionSundayReactionMobile";

export default {
  components: {
    ContentSelectionSundayReactionDesktop,
    ContentSelectionSundayReactionMobile
  },

  data: () => ({
    selection_sunday_reaction_component: null
  }),

  computed: {
    section() {
      if (!this.$root.data) {
        return null;
      }

      return this.$root.data.reaction_section;
    }
  },

  methods: {
    load_component_content() {
      this.selection_sunday_reaction_component = window.matchMedia(
        "(min-width:1025px)"
      ).matches
        ? "content-selection-sunday-reaction-desktop"
        : "content-selection-sunday-reaction-mobile";
    }
  },

  created() {
    this.load_component_content();
    window.addEventListener("resize", () => {
      this.load_component_content();
    });
  }
};
</script>
